




































import { Component, Vue, Prop } from 'vue-property-decorator'
import { EventHub, Events } from '@/classes/event-hub'
import Timer from '@/classes/timer'
import Worker from 'worker-loader!@/classes/cubejs.worker'
import CubeState from '@/classes/cube-state'
import GameState from '@/classes/game-state'

@Component
export default class Scramble extends Vue {
    @Prop()
    private game!: GameState

    private tooltip = false
}
